import * as React from 'react';
import Svg, { Ellipse, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SVGComponent = (props: SvgProps) => (
    <Svg width={props.width ?? 14} height={props.height ?? 8} viewBox="0 0 14 8" fill="none" {...props}>
        <Ellipse cx={7} cy={4} rx={6} ry={3} stroke={props.color || ds.colorValue.icon.primary} strokeWidth={2} />
    </Svg>
);
export { SVGComponent as RescuedIcon };
